import { render, staticRenderFns } from "./AffluenceModal.vue?vue&type=template&id=2767cf48&scoped=true&"
import script from "./AffluenceModal.vue?vue&type=script&lang=ts&"
export * from "./AffluenceModal.vue?vue&type=script&lang=ts&"
import style0 from "./AffluenceModal.vue?vue&type=style&index=0&id=2767cf48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767cf48",
  null
  
)

export default component.exports